export default "__VITE_ASSET__3414c7a1__"